
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.527 2.5a1.655 1.655 0 012.946 0l5.01 9.196c.655 1.201-.163 2.704-1.473 2.704H2.99c-1.31 0-2.128-1.503-1.474-2.704L6.526 2.5zm.437 3.697a1.038 1.038 0 112.073 0l-.16 2.918a.877.877 0 01-1.752 0l-.161-2.918zM8 10.578a.921.921 0 00-.922.922v.11a.921.921 0 101.843 0v-.11A.921.921 0 008 10.579z","fill":"#FF9432"}})])
          )
        }
      }
    